import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './styles.scss';

export default function Button({
  children,
  primary,
  submit,
  secondary,
  onClick,
  ml,
  mr,
  mt,
  mini,
  style,
  stretch,
  raised,
  label,
  ...rest
}) {
  const inline = { ...style, marginLeft: ml, marginRight: mr, marginTop: mt };
  let body = label || children;
  return (
    <button
      className={classNames(styles.btn, {
        [styles.primary]: primary,
        [styles.secondary]: secondary,
        [styles.submit]: submit,
        [styles.mini]: mini,
        [styles.stretch]: stretch,
        [styles.raised]: raised,
      })}
      style={inline}
      onClick={onClick}
      {...rest}
    >
      {body}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.any,
  label: PropTypes.any,
  mini: PropTypes.any,
  ml: PropTypes.number,
  mr: PropTypes.number,
  mt: PropTypes.number,
  onClick: PropTypes.func,
  primary: PropTypes.any,
  raised: PropTypes.any,
  secondary: PropTypes.any,
  stretch: PropTypes.any,
  style: PropTypes.any,
  submit: PropTypes.any,
};
Button.defaultProps = {
  onClick: () => null,
  ml: 5,
  mr: 5,
  mt: 0,
  label: null,
};
